<template>
  <NewPortalSideNav />
  <div class="portal-container flex-grow-1" :class="{
    'p-5': appType === 'embedded',
    'mobile-padding': appType === 'embedded' && !iframeHeaderVisible
  }">
    <div class="content-wrap">
      <div v-if="pending">
        <div
          class="loading-spinner justify-content-center text-center mt-5"
        >
          <div class="spinner-border text-primary"></div>
        </div>
      </div>
      <NuxtPage v-else />
    </div>
    <div class="portal-body-footer-container w-100 mb-3">
      <MarketplaceFooter portal-layout />
    </div>
  </div>
</template>

<script>

import MarketplaceFooter from '~/components/marketplace/MarketplaceFooter'
import NewPortalSideNav from '~/components/portal/NewPortalSideNav'
import { getStyleProps } from '~/libs/customizations'
import { usePortalStore } from '~/store/portal'
import { mapState } from 'pinia'
import { useRootStore } from '~/store/root'
import { useBorrowerStore } from '~/store/borrower'
import { useExperienceStore } from '~/store/experience'
import { useProgressStore } from '~/store/progress'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';

export default {
  name: 'PortalContainer',
  components: {
    MarketplaceFooter,
    NewPortalSideNav,
  },

  async setup() {
    const borrowerStore = useBorrowerStore()
    const progressStore = useProgressStore()

    const { pending } = useLazyAsyncData('portal-container-init', () => Promise.all([
      borrowerStore.getBorrowerValues({ cached: true }),
      borrowerStore.getBorrowerExperiments({ cached: true }),
      borrowerStore.getLenderUser(),
      progressStore.fetchApplications(),
    ]))
    await useExperienceStore().forceGetExperience()

    return {
      pending
    }
  },
  props: ['appType'],
  computed: {
    ...mapState(useBorrowerStore, {
      borrower: (store) => store,
    }),
    ...mapState(usePortalStore, ['isQualifiedBorrower']),
    ...mapState(useAffiliateCustomizationStore, ['iframeHeaderVisible']),
    styleCustomizations() {
      return getStyleProps()
    }
  },
}
</script>

<style lang="scss" scoped>

.portal-body-footer-container {
  position: absolute;
  bottom: 0;
  left: 0;
  @include media-breakpoint-up(lg) {
    padding-left: 15px;
  }
}

.portal-container {
  position: relative;
  min-height: 90vh;

  @include media-breakpoint-up(lg) {
    max-width: max(75%, 100% - 300px);
  }
  @include media-breakpoint-down(lg) {
    &.mobile-padding {
      margin-top: 76px;
    }
  }
}

.content-wrap {
  margin-bottom: 150px;
  flex: 1 0 auto;
  @include media-breakpoint-down(lg) {
    margin-bottom: 250px;
  }
  @include media-breakpoint-down(md) {
    margin-bottom: 325px;
  }
}
</style>
